<template>
	<div class="login">
		<div class="card">
			<!-- 顶部 logo -->
			<div class="logo-box">
				<img src="~@/assets/images/image.png" alt="郑嫂logo" class="logo-img" />
				<div class="sub-title">登录</div>
			</div>

			<el-form label-width="0" class="form">
				<!-- 用户名 -->
				<el-form-item>
					<el-input v-model="data.user_name" prefix-icon="Avatar" placeholder="请输入用户名" maxlength="18"
						@keyup.enter="sublogin" />
				</el-form-item>

				<!-- 密码 -->
				<el-form-item>
					<el-input v-model="upass" type="password" show-password placeholder="请输入登录密码" maxlength="18"
						@keyup.enter="sublogin" autocomplete="new-password" prefix-icon="Lock" />
				</el-form-item>

				<el-form-item>
					<el-input type="password" v-model="uword" prefix-icon="Compass" show-password placeholder="请输入登录口令"
						maxlength="18" @keyup.enter="sublogin" autocomplete="new-password" />
				</el-form-item>

				<!-- 登录按钮 -->
				<el-form-item>
					<el-button type="success" :loading="loading" style="width: 100%" @click="sublogin">
						开始工作
					</el-button>
				</el-form-item>
			</el-form>

			<!-- 可选 slogan -->
			<div class="slogan">供应链源头·把好生产第一关</div>
		</div>
	</div>
</template>

<script>
	import md5 from 'js-md5'
	export default {
		name: 'LoginPage',
		data() {
			return {
				data: {
					user_name: '',
					user_pwd: '',
					user_word: '',
					salt: ''
				},
				upass: '',
				uword: '', // 口令字段保留，但页面隐藏
				loading: false
			}
		},
		mounted() {
			const token = localStorage.getItem('qfyutoken')
			if (token) {
				this.RequestApi('check_login_status.html').then(res => {
					if (res.status === 1) {
						this.OpenUrl('/')
						this.$store.commit('add_exclude', {
							name: 'Login'
						})
					} else {
						localStorage.removeItem('qfyutoken')
						this.$store.commit('clear_tagsview')
					}
				})
			} else {
				this.$store.commit('clear_tagsview')
			}
		},
		methods: {
			sublogin: function() {
				var _this = this;
				if (this.data.user_name == '') return this.TipsError('请填写用户名！');
				if (this.upass == '') return this.TipsError('请填写密码！');
				if (this.uword == '') return this.TipsError('请填写口令！');
				this.data.salt = this.randomString();
				console.log("随机码：",this.data.salt)
				this.data.user_pwd = md5(md5(_this.upass) + this.data.salt);
				this.data.user_word = md5(md5(_this.uword) + this.data.salt);
				this.loading = true;
				this.RequestApi('login_check.html', this.data).then(function(res) {
					if (res.status == 1) {
						localStorage.setItem('qfyutoken', res.token);
						setTimeout(function() {
							_this.loading = false;
							_this.OpenUrl('/')
						}, 1000);
						_this.TipSuccess(res.msg);
					} else {
						_this.loading = false;
						_this.TipsError(res.msg);
					}
				})
			},
			/**
			 * 产生随机字符串
			 */
			randomString: function() {
				let char = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789',
					maxPos = char.length,
					salt = '';
				for (var i = 0; i < 10; i++) {
					salt += char.charAt(Math.floor(Math.random() * maxPos));
				}
				return salt;
			}
		}
	}
</script>

<style lang="less" scoped>
	.login {
		/* 关键：固定高度 = 一屏，宽度 100%，cover 只裁左右 */
		height: 100vh;
		/* 一屏高，上下不动 */
		width: 100%;
		background: url('~@/assets/images/login/333.jpg') center center/cover no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 登录卡片 */
	.card {
		width: 360px;
		padding: 32px 28px 24px;
		background: rgba(255, 250, 240, 0.95);
		/* 饺子皮米白 */
		border-radius: 16px;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
		text-align: center;
	}

	/* logo 区域 */
	.logo-box {
		margin-bottom: 20px;

		.logo-img {
			height: 60px;
			filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
		}

		.sub-title {
			font-size: 18px;
			color: #5c3b1a;
			/* 柴火棕 */
			margin-top: 8px;
			letter-spacing: 2px;
		}
	}

	/* 表单 */
	.form {
		.el-input__wrapper {
			background: rgba(255, 250, 240, 0.9);
			border: 1px solid #d4a574;
			border-radius: 8px;
		}
	}

	/* 按钮 */
	.el-button--success {
		background: #a65c1a;
		border-color: #8b4f1a;
		font-weight: bold;
		letter-spacing: 2px;

		&:hover {
			background: #d49c3c;
			border-color: #b8822e;
		}
	}

	/* slogan */
	.slogan {
		font-size: 12px;
		color: #7a5c3a;
		margin-top: 16px;
		letter-spacing: 1px;
	}
</style>